import React from 'react';
import { connect } from 'react-redux';
import './style.css';
import LayoutWrapper from '../../layouts/LayoutWrapper.js';
import { Calendar, List, Icon, Form, Popover, Spin, Button, Table, Modal, Row, Input } from 'antd';
import { Link } from 'react-router-dom';
// import _util from '../../utils';
import { fetchEmployeeTips, fetchEmployeeImportantTips, closeEmployeeImportantTip } from '../../actions/employee-actions';
import { fetchCompanyCalendarList } from "../../actions/attendance-actions";
import moment from "moment";
import UpdateLoggerService from "../../services/SystemSetting/update-logger-service";

class MobileEmployeeHome extends React.Component {

   state={
	   updateModelStatus:true
   }

	componentWillMount() {
		// console.log(111)
		this.props.fetchEmployeeTips();
		this.props.fetchEmployeeImportantTips();

		let date = {
			calendar_date: moment().format('YYYY-MM')
		}
		this.setState({ currentSelectDate: moment().format("YYYY-MM-DD") });
		this.props.fetchCompanyCalendarList(date);
		// console.log(this.props.attendance)
		setTimeout(() => console.log(this.props.attendance), 3000)
	}
	componentDidMount() {
		// this.props.fetchEmployeeTips();
		// console.log(this.props);
	}

	onPanelChange = moment => {
		let date = {
			calendar_date: moment.format('YYYY-MM')
		}
		this.setState({ currentSelectDate: moment.format("YYYY-MM-DD") });
		this.props.fetchCompanyCalendarList(date);
	}

	HomeLink = () => {
		let result = [];
		if (this.props.access.employeeEmployeeHome.new_daily_rep_value) {
			result.push({
				name: '写日报',
				enname: 'Daily Report',
				icon: 'file-text',
				path: '/report/my-daily-report/1'
			})
		}
		if (this.props.access.employeeEmployeeHome.new_weekly_rep_value) {
			result.push({
				name: '写周报',
				enname: 'Weekly Report',
				icon: 'solution',
				path: '/report/my-weekly-report/1'
			})
		}
		if (this.props.access.employeeEmployeeHome.new_monthly_rep_value) {
			result.push({
				name: '写月报',
				enname: 'Monthly Report',
				icon: 'schedule',
				path: '/report/my-monthly-report/1'
			})
		}
		if (this.props.access.employeeEmployeeHome.apply_leave_value) {
			result.push({
				name: '申请请假',
				enname: 'Apply for leave',
				icon: 'logout',
				path: '/employee/apply-leave'
			})
		}
		if (this.props.access.employeeEmployeeHome.apply_overtime_value) {
			result.push({
				name: '申请加班',
				enname: 'Apply for overtime',
				icon: 'clock-circle-o',
				path: '/employee/apply-overtime'
			})
		}
		if (this.props.access.employeeEmployeeHome.apply_relax_value) {
			result.push({
				name: '申请调休',
				enname: 'Apply to use overtime',
				icon: 'sync',
				path: '/employee/apply-break-down'
			})
		}
		return result;
	}

	dataList = [{
		title: '暂无提醒 No Reminder'
	}]

	dateCellRender = moment => {
		// console.log(this.props.attendance)
		let title = "";
		let content = "";
		let type = 1;
		this.props.attendance.companyCalendar.data.forEach(date => {
			if (date.calendar_date === moment.format('YYYY-MM-DD')) {
				title = date.title;
				content = date.content;
				type = date.calendar_type;
			}
		})
		return (
			<Popover content={content} trigger="hover" title={moment.format("YYYY-MM-DD")}>
				<div style={{ color: type === 2 ? "red" : "" }}>{title}</div>
			</Popover>
		)
	}
	onSelect = moment => {
		// console.log(moment.format("YYYY-MM-DD"))
		this.setState({
			currentSelectDate: moment.format("YYYY-MM-DD"),
			currentData: 1
		})
		// console.log(this.state.currentData);
		this.props.attendance.companyCalendar.data.forEach(date => {
			if (date.calendar_date === moment.format('YYYY-MM-DD')) {
				this.setState({
					currentData: {
						...date
					}
				})
				return;
			}
		})
	}

	//关闭重要提醒
	closeReminder = id => {

		Modal.confirm({
			title: '确定关闭这条重要提醒吗,关闭后不再显示?',
			okText: '确认',
			cancelText: '取消',
			onOk: () => {
				this.props.closeEmployeeImportantTip({ model_id: id }, () => {
					console.log('test');
					this.props.fetchEmployeeImportantTips();
				});

				//   rosterService.deleteEmployees({ ids: this.state.selectedIDs }, result => {
				// 	// console.log(result);
				// 	if (result.data.Success) {
				// 	  this.setState({
				// 		selectedIDs: []
				// 	  }, () => {
				// 		message.success("删除用户成功", 4);
				// 		this.initializePage();
				// 	  })
				// 	} else {
				// 	  message.error("删除用户失败: " + result.data.Message, 4);
				// 	}
				//   }, error => message.error("删除数据失败", 4))
			},
			onCancel: () => { 
			
			}
		});


	}
	closeSystemUpdate=()=>{
		this.setState({updateModelStatus:false})
		UpdateLoggerService.closeUpdateLog({},res=>{
			
		})
	}


	render() {
		const { employeeTips, employeeImportantTips } = this.props.employee;

		const columns = [

			{
				title: '日期',
				dataIndex: 'date_str',
				key: 'date_str',
				className: "table-global-head-short",
				sorter: false
			},
			{
				title: '类型',
				dataIndex: 'type_str',
				key: 'type_str',
				className: "table-global-head-short",
				sorter: false
			},
			{
				title: '操作',
				dataIndex: 'action',
				key: 'action',
				className: "table-global-head-small",
				render: (text, record, index) =>
					<div>
						<Button icon="close" size="small" className="row-action-btn" onClick={this.closeReminder.bind(this, record.id)}>关闭</Button>
					</div>
			},]

		return (
			<div className="app-module-item">
				<div className="EmployeeHomeLeft">
					<div className="MobileTimeItem">
						<div  style={{float:'left'}}>
						当前可用普通调休：<span style={{width:'150px'}}>{employeeTips ? employeeTips.common_relaxation_leftover : 0} 小时</span><br />
						将过期普通调休：<span>{employeeTips ? employeeTips.common_relaxation_expired : 0} 小时</span><br />
						年假总数：<span>{employeeTips ? employeeTips.year_vacation_count : 0} 天</span>
						</div>
						<div style={{float:'left',marginLeft:'10px'}}>
					当前可用因公调休：<span>{employeeTips ? employeeTips.formal_relaxation_leftover : 0} 小时</span><br />
						将过期因公调休：<span>{employeeTips ? employeeTips.formal_relaxation_expired : 0} 小时</span><br />
						当前可用年假：<span>{employeeTips ? employeeTips.yearvacation_leftover : 0} 天</span>
						</div>
						<div style={{clear:'both'}}></div>
					</div>
					<List
						grid={{ gutter: 16, column: 3 }}
						dataSource={this.HomeLink()}
						renderItem={item => (
							<List.Item>
								<Link to={item.path}>
									<div className="mobileMenu">
										<div className="mobileMenuIcon"><Icon type={item.icon} /></div>
										<div className="mobileMenuName">{item.name}<br />{item.enname}</div>
									</div>
								</Link>
							</List.Item>
						)}
					/>
					<div className="remindingImportant">重要提醒 Important Reminder</div>

					{employeeImportantTips && employeeImportantTips.length > 0 ?


						<Table columns={columns}
							dataSource={employeeImportantTips}
							pagination={false}
							rowKey={(record, index) => index}
						/>

						:
						<List
							itemLayout="horizontal"
							dataSource={this.dataList}
							renderItem={item => (
								<List.Item>
									<List.Item.Meta
										title={item.title}
									/>
								</List.Item>
							)}
						/>
					}

				</div>
				{employeeTips && employeeTips.update_log &&
					<Modal width="1000px"

						visible={this.state.updateModelStatus}
						title="系统更新"
						destroyOnClose={true}
						closable={false}
						footer={<Button type="primary" size="default" onClick={this.closeSystemUpdate} >
							<span>知道了</span>
						</Button>}>
						<Form layout="inline">
							<Row>
								<Form.Item >
									<Input.TextArea  
									outline='none'
									className="update_log"
									rows={8} autosize={{ minRows: 4, maxRows: 999 }}
										style={{ width: '760px', border: 'none', resize: 'none',outline:'none',fontSize:'22px' }} value={employeeTips.update_log.update_content} />
								</Form.Item>
							</Row>
						</Form>
					</Modal>
				}
				<div className="EmployeeHomeright" style={{ width: "60%" }}>
					{this.props.attendance.companyCalendar.dataStatus === "loaded" ?
						<div className="employee-calendar" style={{ border: '1px solid #d9d9d9', borderRadius: 4 }}>
							<Calendar fullscreen={true}
								dateCellRender={this.dateCellRender}
								onPanelChange={this.onPanelChange}
								onSelect={this.onSelect} />
						</div>
						: <Spin />
					}
				</div>

			</div>
		)
	}
}
const mapStateToProps = state => {
	return {
		employee: state.employee,
		attendance: state.attendance,
	}
}

const mapDispatchToProps = {
	fetchEmployeeTips,
	fetchEmployeeImportantTips,
	fetchCompanyCalendarList,
	closeEmployeeImportantTip
}

MobileEmployeeHome = Form.create()(MobileEmployeeHome);

export default LayoutWrapper(connect(mapStateToProps, mapDispatchToProps)(MobileEmployeeHome));


// WEBPACK FOOTER //
// ./src/routes/Employee/EmployeeHome.js